import { palette } from '../base/color';
import { typography } from '../base/typography';

const breadcrumbs = {
  color: typography.color.secondary,
  spacer: palette.gray[300],
};

export default breadcrumbs;
